// File is generated in backend, edit api/portfolio/config/initializers/filter_parameter_logging.rb
export const sanitizedKeys = [
  'passw',
  'email',
  'secret',
  'token',
  '_key',
  'crypt',
  'salt',
  'certificate',
  'otp',
  'ssn',
  'password',
  'pin',
  'avatar',
  'currentPassword',
  'supervisorPin',
  'ownerPin',
  'key',
];
